import { render, staticRenderFns } from "./PlatformLogo.vue?vue&type=template&id=3518e29a&scoped=true&"
import script from "./PlatformLogo.vue?vue&type=script&lang=js&"
export * from "./PlatformLogo.vue?vue&type=script&lang=js&"
import style0 from "./PlatformLogo.vue?vue&type=style&index=0&id=3518e29a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3518e29a",
  null
  
)

export default component.exports